import React, { useEffect } from "react";
import { useSearchspringResults } from "@app/hooks/use-searchspring-results";
import { CardProduct } from "@app/components/card-product";
import { COLLECTION_EVENTS, PRODUCT_EVENTS } from "@app/lib/events";
import { SearchspringSearchResult } from "@app/types";

export const viewItemDispatchEvent = (source: "PLP" | "Carousel", item: SearchspringSearchResult, index: number) => {
  const variantsJSON = JSON.parse(((item?.variants as string) ?? [])?.split("&quot;")?.join('"'));
  const variants = variantsJSON;
  document.dispatchEvent(
    new CustomEvent(PRODUCT_EVENTS.SELECT_ITEM, {
      detail: {
        source,
        index,
        variantId: item.uid,
        searchSearchVariantData: { ...item, parsedVariants: variants },
      },
    }),
  );
};

export function ResultGrid() {
  const results = useSearchspringResults();

  useEffect(() => {
    if (!results.length) return;
    /** Used for dispatching the collection data for Google Analytics */
    document.dispatchEvent(
      new CustomEvent(COLLECTION_EVENTS.COLLECTION_VIEW_LIST, {
        detail: results,
      }),
    );
  }, [results]);

  if (!results.length) return null;

  return (
    <div className="grid grid-cols-2 gap-x-2 gap-y-6 px-4 py-6 md:grid-cols-4 md:gap-x-6 md:gap-y-8 md:px-12 md:py-0">
      {results.map((result: string | SearchspringSearchResult, index: number) => {
        if (typeof result === "string") return <div key={result} dangerouslySetInnerHTML={{ __html: result }} />;
        else
          return (
            <div
              onClick={() => {
                viewItemDispatchEvent("PLP", result, index);
              }}
            >
              <CardProduct source="searchspring" data={result} key={result.handle} />
            </div>
          );
      })}
    </div>
  );
}
